import { useEffect, useCallback, createContext, useContext, useMemo, useState } from "react";
import useWireTransferHistory from "../hooks/invoice/useWireTransferHistory";

const WireTransferContext = createContext();

export const WireTransferProvider = ({ children }) => {
  const { wireTransfers, fetchWireTransfers } = useWireTransferHistory();
  const [triggerRefresh, setTriggerRefresh] = useState(false);

  useEffect(() => {
    fetchWireTransfers();
  }, [fetchWireTransfers]);

  const refreshWireTransfers = useCallback(async () => {
    await fetchWireTransfers();
    setTriggerRefresh((prev) => !prev);
  }, [fetchWireTransfers]);

  
  const hasSavedRefId = useMemo(() => {
    return (
      wireTransfers?.data?.some(
        (item) => item.referenceId && !item.depositAmount && !item.paymentProof
      ) || false
    );
  }, [wireTransfers]);

  return (
    <WireTransferContext.Provider
      value={{
        wireTransfers,
        refreshWireTransfers,
        triggerRefresh,
        hasSavedRefId, 
      }}
    >
      {children}
    </WireTransferContext.Provider>
  );
};

export const useWireTransferContext = () => useContext(WireTransferContext);
